"use client"
import Image from "next/image"
import { ClockCircleOutlined } from "@ant-design/icons"
import { Button } from "antd"
import Link from "next/link"
import EnrollmentFormModal from "./enrollment-form-modal"
import { useState } from "react"
import BrochureDownloadModal from "./brochure-download-modal"
interface CourseCardProps {
  title: string
  subtitle: string
  description: string
  duration: string
  imageSrc: string
}
export default function CourseCard({ title, subtitle, description, duration, imageSrc }: CourseCardProps) {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const showModal = () => {
    setIsModalOpen(true)
  }
  const handleClose = () => {
    setIsModalOpen(false)
  }
  const [isBrowcherModalOpen, setIsBrowcherModalOpen] = useState(false)
  const showBrowcherModal = () => {
    setIsBrowcherModalOpen(true)
  }
  const handleBrowcherClose = () => {
    setIsBrowcherModalOpen(false)
  }
  return (
    <div className="bg-white rounded-lg overflow-hidden transition-all hover:shadow-lg border border-gray-200">
      <div className="relative h-52">
        <Image src={imageSrc} alt={title} fill className=" w-[464px] h-[400px] " />
      </div>
      <div className="p-6">
        <div className="mb-2">
          <span className="inline-block px-2 py-1 text-xs font-medium bg-orange/20  text-orange rounded-full">
            {subtitle}
          </span>
        </div>
        <h3 className="text-xl font-bold mb-2">{title}</h3>
        <p className="text-gray-600 mb-4">{description}</p>
        <div className="flex items-center bg-orange/20 w-fit px-3 py-1 rounded-md text-sm text-gray-500 mb-4">
          <ClockCircleOutlined className="mr-1 text-orange" />
          <span>{duration}</span>
        </div>
      </div>
      <div className="p-6 pt-0 flex flex-col sm:flex-row gap-3">
        <button onClick={showModal}
          className="bg-orange hover:bg-lightOrange hover:text-orange text-white font-medium rounded-md px-2 py-[5px] transition duration-300 shadow-md hover:shadow-lg"
        >
          Enroll Now
        </button>
        <EnrollmentFormModal isOpen={isModalOpen} onClose={handleClose} />
        <button onClick={showBrowcherModal}
          className="border border-orange text-orange hover:bg-lightOrange font-medium rounded-md px-2 py-[5px] transition duration-300"
        >
          Download Brochure
        </button>
        <BrochureDownloadModal isOpen={isBrowcherModalOpen} onClose={handleBrowcherClose} />
        <button
          className="border border-orange text-orange hover:bg-lightOrange hover:text-orange font-medium rounded-md px-2 py-[5px] transition duration-300"
        >
          <Link href="offline-courses/web-development-course" className="hover:text-orange">
            Explore More
          </Link>
        </button>
      </div>
    </div>
  )
}